/* Forgotten Tribes — collection listing behaviour.
   - swipeable per-card image galleries with arrows
   - colour swatches: each product's photos are grouped by colour (slides carry
     data-colour). Clicking a swatch shows ONLY that colour's photos, so swiping
     stays within the selected colour instead of drifting into other colours.
     Cards default to their first colour.
   - scroll reveal
   Uses setInterval for the tween (requestAnimationFrame is paused in background
   tabs; scroll-snap:x mandatory cancels programmatic smooth scrolling, so we
   disable snap during the tween and restore it after). */
(function(){
  function tweenTo(rail, target){
    target = Math.max(0, Math.min(target, rail.scrollWidth - rail.clientWidth));
    rail.style.scrollSnapType = 'none';
    var start = rail.scrollLeft, t0 = Date.now(), dur = 320;
    var timer = setInterval(function(){
      var k = Math.min(1, (Date.now() - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      rail.scrollLeft = start + (target - start) * e;
      if (k >= 1) { clearInterval(timer); rail.style.scrollSnapType = ''; }
    }, 16);
  }

  function applyColour(rail, colour){
    var slides = rail.querySelectorAll('.fx-slide');
    var any = false, i;
    for (i = 0; i < slides.length; i++){ if (slides[i].getAttribute('data-colour') === colour){ any = true; break; } }
    if (!any) return false;
    for (i = 0; i < slides.length; i++){ slides[i].hidden = slides[i].getAttribute('data-colour') !== colour; }
    rail.scrollLeft = 0;
    return true;
  }

  function initCard(card){
    var shot = card.querySelector('.fx-shot');
    var rail = shot ? shot.querySelector('[data-fx-gallery]') : null;
    var prev = shot ? shot.querySelector('.fx-nav.prev') : null;
    var next = shot ? shot.querySelector('.fx-nav.next') : null;
    var grouped = !!(rail && rail.hasAttribute('data-fx-grouped'));

    function update(){
      if (!rail || !prev || !next) return;
      var max = rail.scrollWidth - rail.clientWidth - 2;
      prev.hidden = rail.scrollLeft <= 2;
      next.hidden = rail.scrollLeft >= max;
    }

    if (rail && prev && next){
      prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation();
        var w = rail.clientWidth; tweenTo(rail, Math.round(rail.scrollLeft / w) * w - w); setTimeout(update, 360); });
      next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation();
        var w = rail.clientWidth; tweenTo(rail, Math.round(rail.scrollLeft / w) * w + w); setTimeout(update, 360); });
      rail.addEventListener('scroll', update, { passive: true });
    }

    var sws = card.querySelectorAll('.fx-sw[data-colour]');
    function selectColour(sw){
      card.querySelectorAll('.fx-sw').forEach(function(s){ s.classList.remove('is-active'); s.removeAttribute('aria-current'); });
      sw.classList.add('is-active'); sw.setAttribute('aria-current', 'true');
      if (rail && grouped){ applyColour(rail, sw.getAttribute('data-colour')); }
      setTimeout(update, 60);
    }
    sws.forEach(function(sw){ sw.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); selectColour(sw); }); });

    // Default a grouped card to its first colour that actually has photos.
    if (rail && grouped && sws.length){
      var chosen = null;
      for (var i = 0; i < sws.length; i++){
        var c = sws[i].getAttribute('data-colour');
        if (rail.querySelector('.fx-slide[data-colour="' + c + '"]')){ chosen = sws[i]; break; }
      }
      if (chosen){
        chosen.classList.add('is-active'); chosen.setAttribute('aria-current', 'true');
        applyColour(rail, chosen.getAttribute('data-colour'));
      }
    }

    update();
  }

  function initRoot(root){
    if (!root || root.dataset.ftInit) return;
    root.dataset.ftInit = '1';
    root.querySelectorAll('.fx-card').forEach(initCard);

    if (root.dataset.ftAnimate !== '1') return;
    var items = root.querySelectorAll('[data-fx-reveal]');
    if (!items.length) return;
    var pending = [];
    for (var i = 0; i < items.length; i++){
      if (items[i].getBoundingClientRect().top > window.innerHeight * 0.9){
        items[i].classList.add('will-reveal');
        pending.push(items[i]);
      }
    }
    if (!pending.length) return;
    var showReveal = function(el, i){ el.style.transitionDelay = ((i % 4) * 90) + 'ms'; el.classList.add('is-in'); };
    var revealAll = function(){ pending.forEach(function(el){ el.classList.add('is-in'); }); pending = []; };
    if ('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e, i){ if (e.isIntersecting){ showReveal(e.target, i); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      pending.forEach(function(el){ io.observe(el); });
    }
    var sweep = function(){
      if (document.hidden){ revealAll(); return; }
      var left = false;
      pending.forEach(function(el, i){
        if (el.classList.contains('is-in')) return;
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92){ showReveal(el, i); }
        else { left = true; }
      });
      if (!left) window.removeEventListener('scroll', sweep);
    };
    window.addEventListener('scroll', sweep, { passive: true });
    document.addEventListener('visibilitychange', sweep);
    setTimeout(sweep, 400);
  }

  function boot(){ document.querySelectorAll('[id^="ftcol-"]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
